import * as scrollupCss from "./scrollup.module.scss";

export default function scrollUp(element = "wrapper", options) {
  const upButton = document.createElement("div");
  upButton.id = scrollupCss.up;
  upButton.title = options.title || "Scrolle nach oben";
  upButton.setAttribute("role", "button");
  upButton.tabIndex = 0;
  const wrapper = document.getElementById("wrapper");
  wrapper.insertAdjacentElement("afterend", upButton);

  upButton.addEventListener("click", animateScrollUp);

  function animateScrollUp(e) {
    e.preventDefault();
    jQuery("html,document").animate({
      scrollTop: 0,
    });
  }
}
